import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface ObjetoContrato {
  id: number;
  descripcion: string;
  isFuec?: number;
  isContrato?: number;
}

@Injectable({
  providedIn: 'root'
})
export class ObjetosContratosService {
  private apiUrl =  `${environment.apiUrl}/api/objetosContratos`; 
  //private apiUrl = 'http://localhost:3000/api/objetosContratos'; // Ajusta la URL si es necesario

  constructor(private http: HttpClient) {}

  getObjetos(): Observable<ObjetoContrato[]> {
    return this.http.get<ObjetoContrato[]>(this.apiUrl);
  }

  createObjeto(objeto: ObjetoContrato): Observable<ObjetoContrato> {
    return this.http.post<ObjetoContrato>(this.apiUrl, objeto);
  }

  updateObjeto(id: number, objeto: ObjetoContrato): Observable<ObjetoContrato> {
    return this.http.put<ObjetoContrato>(`${this.apiUrl}/${id}`, objeto);
  }

  deleteObjeto(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }
}